import firebase from 'firebase/app';
import 'firebase/messaging';
const { log } = console;


if (firebase.apps.length === 0) {
  const firebaseConfig = {
    apiKey: 'AIzaSyDelEzws4QtrfYkvO7Ysbu2Jxs3WgRN1LM',
    authDomain: 'fcm-demo-sms.firebaseapp.com',
    projectId: 'fcm-demo-sms',
    storageBucket: 'fcm-demo-sms.appspot.com',
    messagingSenderId: '24364247800',
    appId: '1:24364247800:web:39cd50da0290db4c0be90d',
    measurementId: 'G-6TT323N48Q',
  };
  
  console.log('***FCM Init: Foreground***');
  firebase.initializeApp(firebaseConfig);
}

// Lazy initialization of messaging - only when needed and if supported
let messaging = null;
let messagingInitialized = false;
let messagingUnsupported = false;

const browserHasRequiredApis = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const hasServiceWorker = 'serviceWorker' in navigator;
  const hasNotification = 'Notification' in window;
  const isSecureContext = window.isSecureContext || window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  return hasServiceWorker && hasNotification && isSecureContext;
};

const canUseFirebaseMessaging = () => {
  if (!browserHasRequiredApis()) {
    return false;
  }

  if (firebase.messaging && typeof firebase.messaging.isSupported === 'function') {
    try {
      return firebase.messaging.isSupported();
    } catch (error) {
      console.warn('Unable to determine Firebase messaging support, falling back to default check', error);
      // Fall back to assuming support so Firebase can handle edge cases (e.g. iOS web push)
      return true;
    }
  }

  // If firebase.messaging.isSupported is not available, assume support and rely on Firebase to throw if not supported
  return true;
};

const getMessaging = () => {
  // If we've already determined messaging is unsupported, don't try again
  if (messagingUnsupported) {
    return null;
  }
  
  // Check for basic browser context
  if (typeof window === 'undefined') {
    return null; // Server-side rendering
  }
  
  // If already initialized, return the instance
  if (messagingInitialized && messaging) {
    return messaging;
  }
  
  // Try to initialize messaging - Firebase will throw if unsupported
  if (!messagingInitialized) {
    if (!canUseFirebaseMessaging()) {
      messagingUnsupported = true;
      console.warn('Firebase Cloud Messaging prerequisites missing in this browser (service worker / notifications / HTTPS).');
      return null;
    }

    try {
      messaging = firebase.messaging();
      messagingInitialized = true;
      console.log('***FCM Enabled: Foreground***');
    } catch (error) {
      // Handle unsupported browser error
      if (
        error &&
        (error.code === 'messaging/unsupported-browser' || 
         (error.message && error.message.includes('unsupported-browser')) ||
         (error.message && error.message.includes("doesn't support the API")) ||
         (error.message && error.message.includes("required to use")))
      ) {
        messagingUnsupported = true;
        console.warn('Firebase Cloud Messaging is not supported in this browser:', error.message || error.code);
        return null;
      }
      // For other errors, log but allow re-attempts on next call
      console.error('Failed to initialize Firebase Messaging:', error);
      messagingUnsupported = false;
      return null;
    }
  }
  
  return messaging;
};

// Helper function to ensure service worker is registered and ready (critical for iOS)
const ensureServiceWorkerReady = async () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    console.warn('Service Worker API not available');
    return false;
  }

  const swUrl = `${process.env.PUBLIC_URL || ''}/firebase-messaging-sw.js`;
  
  try {
    // Check if service worker is already registered
    const registrations = await navigator.serviceWorker.getRegistrations();
    let existingRegistration = registrations.find(reg => 
      reg.active && reg.active.scriptURL && reg.active.scriptURL.includes('firebase-messaging-sw.js')
    );

    // If no active registration, check for installing/waiting workers
    if (!existingRegistration) {
      existingRegistration = registrations.find(reg => {
        const worker = reg.installing || reg.waiting || reg.active;
        const scriptUrl = worker && worker.scriptURL;
        return scriptUrl && scriptUrl.includes('firebase-messaging-sw.js');
      });
    }

    if (existingRegistration) {
      // Service worker is registered, wait for it to become active
      const installingWorker = existingRegistration.installing;
      const waitingWorker = existingRegistration.waiting;
      const activeWorker = existingRegistration.active;
      
      // If already active, we're good
      if (activeWorker && activeWorker.scriptURL && activeWorker.scriptURL.includes('firebase-messaging-sw.js')) {
        await navigator.serviceWorker.ready;
        console.log('Firebase messaging service worker is already active and ready');
        return true;
      }
      
      if (installingWorker) {
        // Wait for installation to complete
        await new Promise((resolve, reject) => {
          const timeout = setTimeout(() => {
            resolve(); // Resolve anyway to not block
          }, 10000); // 10 second timeout
          
          const checkState = () => {
            if (!installingWorker) {
              clearTimeout(timeout);
              resolve();
              return;
            }
            
            const state = installingWorker.state;
            if (state === 'activated' || state === 'activated') {
              clearTimeout(timeout);
              resolve();
            } else if (state === 'redundant') {
              clearTimeout(timeout);
              resolve(); // Resolve to continue
            }
          };
          
          installingWorker.addEventListener('statechange', checkState);
          // Check initial state
          checkState();
        });
      } else if (waitingWorker) {
        // Activate waiting service worker
        try {
          waitingWorker.postMessage({ type: 'SKIP_WAITING' });
          await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
          console.warn('Error activating waiting service worker:', error);
        }
      }
      
      // Wait for service worker to be ready (iOS requires this)
      try {
        await navigator.serviceWorker.ready;
      } catch (error) {
        console.warn('Service worker ready check failed:', error);
      }
      
      // Double-check that we have an active service worker
      const updatedRegistrations = await navigator.serviceWorker.getRegistrations();
      const activeRegistration = updatedRegistrations.find(reg => 
        reg.active && reg.active.scriptURL && reg.active.scriptURL.includes('firebase-messaging-sw.js')
      );
      
      if (activeRegistration && activeRegistration.active) {
        console.log('Firebase messaging service worker is ready and active');
        return true;
      }
    }

    // Service worker not found, register it
    console.log('Registering Firebase messaging service worker...');
    const registration = await navigator.serviceWorker.register(swUrl, {
      scope: '/'
    });

    // Wait for service worker to install and activate
    const installingWorker = registration.installing;
    if (installingWorker) {
      await new Promise((resolve) => {
        const timeout = setTimeout(() => {
          resolve(); // Resolve anyway to not block
        }, 10000); // 10 second timeout
        
        const checkState = () => {
          if (!installingWorker) {
            clearTimeout(timeout);
            resolve();
            return;
          }
          
          const state = installingWorker.state;
          if (state === 'activated') {
            clearTimeout(timeout);
            resolve();
          } else if (state === 'redundant') {
            clearTimeout(timeout);
            resolve(); // Resolve to continue
          }
        };
        
        installingWorker.addEventListener('statechange', checkState);
        // Check initial state
        checkState();
      });
    }

    // Wait for service worker to be ready (critical for iOS)
    try {
      await navigator.serviceWorker.ready;
      console.log('Firebase messaging service worker registered and ready');
      return true;
    } catch (error) {
      console.warn('Service worker ready failed:', error);
      // If service worker is already active, return true anyway
      const registrations = await navigator.serviceWorker.getRegistrations();
      const hasActive = registrations.some(reg => 
        reg.active && reg.active.scriptURL && reg.active.scriptURL.includes('firebase-messaging-sw.js')
      );
      if (hasActive) {
        console.log('Firebase messaging service worker is active');
        return true;
      }
      return false;
    }
  } catch (error) {
    console.error('Error ensuring service worker is ready:', error);
    return false;
  }
};

export const getFirebaseToken = async (refreshCallBack = undefined) => {
  const messagingInstance = getMessaging();
  
  if (!messagingInstance) {
    console.warn('Firebase Cloud Messaging is not supported in this browser');
    return false;
  }
  
  // Ensure service worker is ready before requesting token (required for iOS)
  console.log('Ensuring service worker is ready before requesting FCM token...');
  try {
    const swReady = await Promise.race([
      ensureServiceWorkerReady(),
      new Promise((_, reject) => setTimeout(() => reject(new Error('Service worker ready timeout')), 15000))
    ]);
    
    if (!swReady) {
      console.warn('Service worker is not ready, retrying in a moment...');
      // Retry after a short delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      const swReadyRetry = await Promise.race([
        ensureServiceWorkerReady(),
        new Promise((_, reject) => setTimeout(() => reject(new Error('Service worker ready timeout')), 10000))
      ]);
      if (!swReadyRetry) {
        console.warn('Service worker failed to become ready after retry, attempting to get token anyway...');
        // Continue anyway - sometimes iOS can still get tokens without perfect service worker state
      }
    } else {
      console.log('Service worker is ready, proceeding with token request');
    }
  } catch (error) {
    console.warn('Service worker ready check failed or timed out:', error);
    console.warn('Attempting to get token anyway (may work on some browsers)...');
    // Continue anyway - don't block token generation
  }
  
  try {
    // Preventively delete the token if it exists
    try {
      await messagingInstance.deleteToken();
    } catch (error) {
      console.log(error);
    }
    const currentToken =
      process.env.REACT_APP_FCM_LOCAL_TESTING === 'false'
        ? await messagingInstance.getToken()
        : await messagingInstance.getToken({
          vapidKey:
            'BMpF3ewHCKWYpNVDJu3CRqslM8LJP9E9aXNiUiAvj6sBIooRWWzaKX29UN5U_EmbXhAhDMYcRhpsLrNYCpQ0Pkc',
        });

    log({
      page: 'firebase',
      function: 'initializeFirebaseToken-> getFirebaseToken',
      name: 'initializeFirebaseToken',
      data: {
        refreshCallBack
      },
      message: 'Calling getToken function from firebase library.',
      date: new Date()
    })
    if (currentToken) {
      log({
        page: 'firebase',
        function: 'initializeFirebaseToken-> getFirebaseToken',
        name: 'initializeFirebaseToken',
        data: {
          refreshCallBack,
          currentToken
        },
        message: 'Getting token',
        date: new Date()
      })
      console.log('New FCM token for client: ', currentToken);
      return currentToken;
      // Track the token -> client mapping, by sending to backend server
      // show on the UI that permission is secured
    } else {
      log({
        page: 'firebase',
        function: 'initializeFirebaseToken-> getFirebaseToken',
        name: 'initializeFirebaseToken',
        data: {
          refreshCallBack
        },
        message: 'Error while taking token from firebase',
        date: new Date()
      })
      console.log(
        'No registration token available. Request permission to generate one.'
      );
      return false;
      // shows on the UI that permission is required
    }
  } catch (err) {
    log({
      page: 'firebase',
      function: 'initializeFirebaseToken-> getFirebaseToken',
      name: 'initializeFirebaseToken',
      data: {
        refreshCallBack
      },
      message: 'Error message from firebase registration ' + err,
      date: new Date()
    })
    console.log('An error occurred while retrieving token. ', err);
    
    // Handle unsupported browser error
    if (
      err &&
      (err.code === 'messaging/unsupported-browser' || 
       (err.message && err.message.includes('unsupported-browser')) ||
       (err.message && err.message.includes("doesn't support the API")))
    ) {
      console.warn('Firebase Cloud Messaging is not supported in this browser');
      return false;
    }
    
    if (
      err &&
      err.message &&
      err.message.includes('no active Service Worker')
    ) {
      log({
        page: 'firebase',
        function: 'initializeFirebaseToken-> getFirebaseToken',
        name: 'initializeFirebaseToken',
        data: {
          refreshCallBack
        },
        message: 'Trying to regenerate firebasetoken',
        date: new Date()
      })
      refreshCallBack && refreshCallBack();
    }
    return false;
  }
};

export const deleteFirebaseToken = async () => {
  const messagingInstance = getMessaging();
  
  if (!messagingInstance) {
    console.warn('Firebase Cloud Messaging is not supported in this browser');
    // Still remove from localStorage even if messaging is not supported
    try {
      const userFromSession = sessionStorage.getItem('user');
      let usernameFromSession = null;
      if (userFromSession) {
        const user = JSON.parse(userFromSession);
        if (user && user.username) {
          usernameFromSession = user.username;
        }
      }
      const selectedLocation = localStorage.getItem('selectedLocation');
      const fcmTokenKey = `fcmToken${usernameFromSession}${selectedLocation}`;
      localStorage.removeItem(fcmTokenKey);
    } catch (error) {
      console.log(error);
    }
    return false;
  }
  
  try {
    const userFromSession = sessionStorage.getItem('user');
    let usernameFromSession = null;
    if (userFromSession) {
      const user = JSON.parse(userFromSession);
      if (user && user.username) {
        usernameFromSession = user.username;
      }
    }
    const selectedLocation = localStorage.getItem('selectedLocation');
    const fcmTokenKey = `fcmToken${usernameFromSession}${selectedLocation}`;
    const fcmToken = localStorage.getItem(fcmTokenKey);
    await messagingInstance.deleteToken();
    localStorage.removeItem(fcmTokenKey);
    console.log('FCM Token deleted: ', fcmToken);
    return true;
  } catch (error) {
    console.log(error);
    // Handle unsupported browser error
    if (
      error &&
      (error.code === 'messaging/unsupported-browser' || 
       (error.message && error.message.includes('unsupported-browser')) ||
       (error.message && error.message.includes("doesn't support the API")))
    ) {
      console.warn('Firebase Cloud Messaging is not supported in this browser');
    }
    return false;
  }
};

export const onMessageListenerFCM = () =>
  new Promise((resolve, reject) => {
    const messagingInstance = getMessaging();
    
    if (!messagingInstance) {
      console.warn('Firebase Cloud Messaging is not supported in this browser');
      // Return a promise that never resolves instead of rejecting
      // This prevents error logs in components that call this function
      return;
    }
    
    try {
      messagingInstance.onMessage((payload) => {
        console.log('Message received: ', payload);
        resolve(payload);
      });
    } catch (error) {
      console.error('Error setting up FCM message listener:', error);
      // Handle unsupported browser error silently
      if (
        error &&
        (error.code === 'messaging/unsupported-browser' || 
         (error.message && error.message.includes('unsupported-browser')) ||
         (error.message && error.message.includes("doesn't support the API")))
      ) {
        console.warn('Firebase Cloud Messaging is not supported in this browser');
        return;
      }
      reject(error);
    }
  });



// WEBPACK FOOTER //
// ./src/config/firebase.js